import React, { useEffect } from "react"
import TechnologiesList from "../../features/technologies-list"

import DjangoLogo from "../../assets/images/technologies/django2.svg"
import PandasLogo from "../../assets/images/technologies/pandas.svg"
import ReactLogo from "../../assets/images/technologies/React.svg"
import PythonLogo from "../../assets/images/technologies/Python.svg"
import DatadogLogo from "../../assets/images/technologies/datadog.svg"
import TypescriptLogo from "../../assets/images/technologies/typescript.svg"
import DockerLogo from "../../assets/images/technologies/docker.svg"

import CaseProjectBlock from "../../features/case-project-block"
import { PROJECT_CRAFT } from "../../data/cases/project-data"
import CasesSays from "../../features/cases-client"
import { DEVELOPERS_LIST_CRAFT } from "../../data/cases/developers-data"
import CaseDeveloper from "../../features/case-developer"
import { CRAFT } from "../../data/cases/seo-says"
import ChallengesSolutions from "../../features/challenges-solutions"
import { CHALLENGES_LIST_CRAFT } from "../../data/cases/challenges-data"
import { SOLUTIONS_LIST_CRAFT } from "../../data/cases/solutions-data"
import { HEADER_CRAFT } from "../../data/cases/headers-data"
import { OtherCases } from "../../features/other-cases"
import "./index.scss"
import CaseCustomHeader from "../../features/case-custom-header"
import { useMediaQuery } from "react-responsive"
import { DESKTOP_WIDTH } from "../../constants/common"
import { Helmet } from "react-helmet-async"

const Craft = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const isDesktop = useMediaQuery({ minWidth: DESKTOP_WIDTH })

    return (
        <>
            <Helmet defer={false}>
                <title>Newsoft - Craft</title>
            </Helmet>
            <div className="craft">
                <CaseCustomHeader {...HEADER_CRAFT} />
                <div className="try-now-image">
                    <img
                        src="https://s3.amazonaws.com/staging.newsoft-website-v2/media/craft_case/Craft.webp"
                        alt="Craft main"
                    />
                </div>
                <TechnologiesList title="Key technologies">
                    <img
                        src={DjangoLogo}
                        alt="Django logo"
                        style={isDesktop ? { width: "113px" } : {}}
                    />
                    <img
                        src={PandasLogo}
                        alt="Pandas logo"
                        style={isDesktop ? { width: "170px" } : {}}
                    />
                    <img
                        src={ReactLogo}
                        alt="React logo"
                        style={isDesktop ? { width: "54px" } : {}}
                    />
                    <img
                        src={PythonLogo}
                        alt="Python logo"
                        style={isDesktop ? { width: "50px" } : {}}
                    />
                    <img
                        src={DatadogLogo}
                        alt="Datadog logo"
                        style={isDesktop ? { width: "50px" } : {}}
                    />
                    <img
                        src={TypescriptLogo}
                        alt="Typescript logo"
                        style={isDesktop ? { width: "152px" } : {}}
                    />
                    <img
                        src={DockerLogo}
                        alt="Docker logo"
                        style={isDesktop ? { width: "193px" } : {}}
                    />
                </TechnologiesList>
                <CaseProjectBlock {...PROJECT_CRAFT} />
                <div className="try-now-developers">
                    <h2 className="t-s3 desk">developer quotes</h2>
                    {DEVELOPERS_LIST_CRAFT.map((el, id) => (
                        <CaseDeveloper
                            key={el.name}
                            {...el}
                            header={id === 0 && "developer quotes"}
                        />
                    ))}
                </div>
                <CasesSays data={CRAFT} header="What our CEO says" />
                <ChallengesSolutions
                    challenges={CHALLENGES_LIST_CRAFT}
                    solutions={SOLUTIONS_LIST_CRAFT}
                />
                <OtherCases currentCase="/cases/quarkworks/craft" />
            </div>
        </>
    )
}

export default Craft
